import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useShopStage } from '@hooks';
import { useAddReferralsToHomePageRecommendation } from '../modules/AddReferralsToHomePageRecommendation';
import { useCartAbandonmentEmailPromoRecommendation } from '../modules/CartAbandonmentEmailPromoRecommendation';
import { useCreateProductRecommendation } from '../modules/CreateProductRecommendation';
// import { useCreatorChallengeRecommendation } from '../modules/CreatorChallengeRecommendation'
import { useCustomDomainRecommendation } from '../modules/CustomDomainRecommendation';
// import { useDigitalProductRecommendation } from '../modules/DigitalProductRecommendation'
import { useFreeShippingRecommendation } from '../modules/FreeShippingRecommendation/hooks/useFreeShippingRecommendation';
import { useHomeProductsRecommendation } from '../modules/HomeProductsRecommendation';
import { useInviteTeamRecommendation } from '../modules/InviteTeamRecommendation';
// import { useMembershipsRecommendation } from '../modules/MembershipsRecommendation'
import { useOrderSamplesRecommendation } from '../modules/OrderSamplesRecommendation/hooks/useOrderSamplesRecommendation';
import { usePromotionsRecommendation } from '../modules/PromotionsRecommendation';
import { useReferralRecommendation } from '../modules/ReferralRecommendation';
import { useSocialLinksRecommendation } from '../modules/SocialLinksRecommendation';
import { useThankYouRecommendation } from '../modules/ThankYouRecommendation';
export const useWebviewRecommendations = () => {
    const { homeProductsRecommendation } = useHomeProductsRecommendation();
    const { createProductRecommendation } = useCreateProductRecommendation();
    const { orderSamplesRecommendation } = useOrderSamplesRecommendation();
    const { addReferralLinkToHomepageRecommendation } = useAddReferralsToHomePageRecommendation();
    const { freeShippingRecommendation } = useFreeShippingRecommendation();
    const { cartAbandonmentEmailPromoRecommendation } = useCartAbandonmentEmailPromoRecommendation();
    const { customDomainRecommendation } = useCustomDomainRecommendation();
    const { referralRecommendation } = useReferralRecommendation();
    const { inviteTeamRecommendation } = useInviteTeamRecommendation();
    const { promotionsRecommendation } = usePromotionsRecommendation();
    const { socialLinksRecommendation } = useSocialLinksRecommendation();
    const { thankYouRecommendation } = useThankYouRecommendation();
    // TODO: enable these recommendations once they are ready to show on mobile view
    // const { creatorChallengeRecommendation } = useCreatorChallengeRecommendation()
    // const { digitalProductRecommendation } = useDigitalProductRecommendation()
    // const { membershipsRecommendation } = useMembershipsRecommendation()
    const { shopStage } = useShopStage();
    useEffect(() => {
        if (shopStage.currentStage) {
            TagManager.dataLayer({ dataLayer: { shopStage: shopStage.currentStage } });
        }
    }, [shopStage.currentStage]);
    const recommendations = [
        // creatorChallengeRecommendation,
        homeProductsRecommendation,
        createProductRecommendation,
        orderSamplesRecommendation,
        addReferralLinkToHomepageRecommendation,
        freeShippingRecommendation,
        cartAbandonmentEmailPromoRecommendation,
        customDomainRecommendation,
        referralRecommendation,
        inviteTeamRecommendation,
        promotionsRecommendation,
        socialLinksRecommendation,
        thankYouRecommendation,
        // digitalProductRecommendation,
        // membershipsRecommendation,
    ];
    const isLoadingRecommendations = recommendations.some(({ isLoading }) => isLoading);
    const enabledRecommendations = (() => {
        return recommendations.filter(({ enabled }) => enabled);
    })();
    return { recommendations: !isLoadingRecommendations ? enabledRecommendations : undefined };
};
